import { resolveUrl } from "../../utils/url/urlResolver";
import { type NotificationDTO } from "./dto";
import { type NotificationData } from "~/Notifications/Messages";

interface ResponseDTO {
  results: NotificationDTO[];
  pagination: {
    currentPage: number;
    numberOfPages: number;
    pageSize: number;
    totalNumberOfResults: number;
  };
}

export async function fetchNotifications() {
  const url = resolveUrl(`/notifications/pagedata`);

  const response = await fetch(url, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
  });

  const dto: ResponseDTO = await response.json();

  return {
    results: dto.results as NotificationData[],
    totalAmount: dto.pagination.totalNumberOfResults,
  };
}
